import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

import { replaceWithRequiredSiteInfo } from '@/helper/wordReplace';
import { SITE_TITLE, SITE_URL } from '@/utils/constants';

const Accordions = ({ title, content, index, siteUrl }: any) => {
  const brand = SITE_TITLE;
  const brandUrl = siteUrl ? `https://${siteUrl}` : SITE_URL;
  return (
    <Accordion defaultActiveKey="0" className="sv-accordion mb-4">
      <Accordion.Item eventKey={index}>
        <Accordion.Header>
          {replaceWithRequiredSiteInfo(brand, brandUrl, title)}
        </Accordion.Header>
        <Accordion.Body>
          <div
            className="card-content"
            dangerouslySetInnerHTML={{
              __html: replaceWithRequiredSiteInfo(brand, brandUrl, content),
            }}
          ></div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default Accordions;
